import { IHttpProvider } from "./base/HttpProvider";
import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

export class AxiosHttpProvider implements IHttpProvider {
    async get(url: string, config: AxiosRequestConfig): Promise<AxiosResponse> {
        return await axios.get(url, config);
    }

    async post(url: string, body: unknown, config: AxiosRequestConfig): Promise<AxiosResponse> {
        return axios.post(url, body, config);
    }

    async request(config: AxiosRequestConfig): Promise<AxiosResponse> {
        return axios(config);
    }
}
